import React from 'react'
import Img from 'gatsby-image';
import Link from 'components/Link';
import { Container } from 'reactstrap';

export default (props) => {
  const { content } = props;
  return (
    <React.Fragment>
      <div className="wrapper post-image">
        <Img sizes={props.data.img.childImageSharp.sizes}
          backgroundColor="rgba(51,102,255,0.4)"
        />
      </div>

      <Container className="my-5 pb-5">

        <h3 className="mb-3 text-color-title">{content.title}</h3>
        <h5 className="text-color-subtitle">{content.headline}</h5>

        <br/>

        <p>{content.p1}</p>
        <br />
        <p>{content.p2}</p>
        <br />
        <p>{content.p3}</p>
        <br />
        <p>{content.p4}</p>
        <a href="https://fivethirtyeight.com/features/one-last-dispatch-from-the-land-of-chess-kings-and-billionaires/">https://fivethirtyeight.com/features/one-last-dispatch-from-the-land-of-chess-kings-and-billionaires/</a>

        <div className="text-right my-5">
        <Link to="/competency">Back to competency</Link>
        </div>
        
      </Container>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/pages/competency/training/_trainingLayout.js